import { GAME_ID, REDUX_ACTIONS, LEVEL_ITEM_CONFIGURATIONS, SCREENS } from '../../../data/constants';
import { worksheetActionTypes } from '../../../../components/worksheet/data/constants';

const initialState = {
  itemIndex: 0, // the number of standard items completed. (not including onboarding)
  maxItemIndex: 0, // the number of standard items in the round. (not including onboarding)
  firstTry: true,
  roundOver: false,
  isItemComplete: false,
  isReadyToInitNextItem: false,
  itemsMasteredThisRound: [],
  lastLevelUnlocked: 0,

  // wether or not the current item is an onboarding item.
  // used to prevent user from recieving mastery credit after completing an onboarding item.
  inOnboarding: false,

  currentScreen: SCREENS.PROGRESS,
  hasSeenOnboarding: {
    [SCREENS.SINGLE_IMAGE]: false,
    [SCREENS.MULTI_IMAGE]: false,
    [SCREENS.TEXT]: false,
    [SCREENS.VARIETY]: false,
  },
};

const progressReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_IN_ONBOARDING:
      return {
        ...state,
        inOnboarding: payload,
      };

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM: {
      const hasSeenOnboarding = { ...state.hasSeenOnboarding };
      const isLastOnboardingQuestion = state.inOnboarding && !payload?.isStillInOnboarding;

      if (isLastOnboardingQuestion) {
        hasSeenOnboarding[state.currentScreen] = true;
      }

      return {
        ...state,
        itemIndex: state.itemIndex + (state.inOnboarding ? 0 : 1),
        firstTry: true,
        isReadyToInitNextItem: true,
        hasSeenOnboarding,
      };
    }

    case REDUX_ACTIONS.SET_IS_ITEM_COMPLETE:
      return {
        ...state,
        isItemComplete: payload,
      };

    case REDUX_ACTIONS.INIT_STANDARD_ITEM:
      return {
        ...state,
        isItemComplete: false,
        isReadyToInitNextItem: false,
      };

    case REDUX_ACTIONS.SET_IS_READY_TO_INIT_NEXT_ITEM:
      return {
        ...state,
        isReadyToInitNextItem: payload,
      };

    case REDUX_ACTIONS.END_ROUND:
      return {
        ...state,
        roundOver: true,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        itemIndex: 0,
        firstTry: true,
        roundOver: false,
      };

    case REDUX_ACTIONS.SET_LEVEL:
      return {
        ...state,
        currentScreen: LEVEL_ITEM_CONFIGURATIONS[payload.level].screen,
        maxItemIndex: LEVEL_ITEM_CONFIGURATIONS[payload.level].itemsInRound,
      };

    case worksheetActionTypes.ON_INCORRECT_START:
      return {
        ...state,
        firstTry: false,
      };

    case worksheetActionTypes.ON_CORRECT_START: {
      const itemsMasteredThisRound = [...state.itemsMasteredThisRound];
      if (state.firstTry && !state.inOnboarding) {
        itemsMasteredThisRound.push(payload.details.id);
      }
      return {
        ...state,
        itemsMasteredThisRound,
      };
    }

    case REDUX_ACTIONS.CLEAR_MASTERED_ITEMS:
      return {
        ...state,
        itemsMasteredThisRound: [],
      };

    case REDUX_ACTIONS.TRY_UNLOCK_LEVEL:
      return {
        ...state,
        lastLevelUnlocked: Math.max(state.lastLevelUnlocked, payload),
      };

    case REDUX_ACTIONS.QUICK_ROUND:
      return {
        ...state,
        itemIndex: payload.items.length,
        maxItemIndex: payload.items.length,
        itemsMasteredThisRound: payload.pass ? payload.items : [],
      };

    default:
      return state;
  }
};

export default progressReducer;
